import moment from "moment";
import { createContext } from "react";
import { formatTimeRange } from "util/time";

/** The time picked in the strip, while the booking pop-up is open. */
export type GutterBooking = { start: Date; end: Date };

export type GutterBookingContextValue = {
  booking: GutterBooking | null;
  /** Where the pop-up opened, which it stays anchored to. */
  anchor: GutterBooking | null;
  openBooking: (booking: GutterBooking) => void;
};

export const GutterBookingContext =
  createContext<GutterBookingContextValue | null>(null);

/** "Tuesday, October 6 · 4:15 – 6:00 pm" */
export function formatDayAndTimeRange(
  start: Date | string,
  end: Date | string
) {
  return `${moment(start).format("dddd, MMMM D")} · ${formatTimeRange(
    start,
    end
  )}`;
}
